import axios from "axios";
import { newAbortSignal } from "../../../utils";
import { SessionStore } from "../../../types/store";
import { FeatureCollection } from "../../../types/model/captureLocation";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/locations`;

export const getWaterBodiesLayer = async (): Promise<FeatureCollection> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<FeatureCollection>(`${BASE_URL}/water-bodies`, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
